// @flow
import React, {Component} from 'react';
import {StyleSheet, Switch, View, Platform} from 'react-native';
import {ActivityIndicator, Text} from 'trpc-react-native-ui';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import {getRenewalDate} from '../../../lib/date-utils';
import SwitchPlanModePostRequestModal from '../SwitchPlanModePostRequestModal.container';
import Modal from '../../common/ConfirmationModal/Modal';

class PlanRenewer extends Component<Props, State> {
  state = {
    isModalOpen: false,
    switchValue: false,
  };

  styles = getStyles();

  _getRenewalDate(fromNow) {
    return getRenewalDate(this.props.subscription.nextRenewalDate || fromNow);
  }

  _renderLabel(styles) {
    const textStyles = [styles.strongText];
    if (!this.props.switchValue) {
      textStyles.push(styles.warningText);
    }
    return (
      <View style={styles.labelView}>
        <Text style={textStyles}>
          {I18n.t(this.props.switchValue ? 'autoRenews' : 'stopsOn', {
            date: this._getRenewalDate(),
          })}
        </Text>
      </View>
    );
  }

  handleSubmit = () => {
    this.closeModal();
    this.props.switchMode(this.state.switchValue);
  };

  displayConfirmationModal = value => {
    if (!value) {
      this.openModal();
    } else {
      this.props.switchMode(value);
    }
    this.changeSwitchValue(value);
  };

  openModal = () => this.setState({isModalOpen: true});
  closeModal = () => this.setState({isModalOpen: false});
  changeSwitchValue = value => this.setState({switchValue: value});

  render() {
    const styles = this.styles;
    if (!this.props.subscription) {
      return <ActivityIndicator style={styles.loader} />;
    }

    // Ugly fix because of RN 0.81 Switch size changes on iOS
    // see https://github.com/facebook/react-native/issues/53537
    // see https://github.com/facebook/react-native/pull/54155
    const switchSizeGteIos26 = { width: 63, height: 28 };
    const switchSizeLteIos18 = { width: 51, height: 31 };
    const switchSize = Platform.OS === 'ios' && parseInt(Platform.Version) >= 26 ? switchSizeGteIos26 : switchSizeLteIos18;

    return (
      <View style={this.props.style}>
        <View>
          <View style={styles.innerContainer}>
            <View style={styles.renewalDate}>{this._renderLabel(styles)}</View>
            <View style={styles.switchView}>
              <View>
                <Text style={styles.switchLeftText}>{I18n.t('OFF')}</Text>
              </View>
              <View style={styles.switchButton}>
                <Switch
                  style ={switchSize}
                  onValueChange={value => this.displayConfirmationModal(value)}
                  value={this.props.switchValue}
                  disabled={this.props.disabled || this.props.isChangingMode}
                />
              </View>
              <View>
                <Text>{I18n.t('ON')}</Text>
              </View>
            </View>
          </View>
          {this.props.disabled && (
            <Text style={styles.disabledText}>
              {I18n.t('Dashboard.PlanRenewer.disabledText')}
            </Text>
          )}
        </View>
        <Modal
          confirm={this.handleSubmit}
          cancel={this.closeModal}
          opened={this.state.isModalOpen}
          confirmContent={I18n.t('ChangePlan.modeOffModalContent')}
        />
        <SwitchPlanModePostRequestModal />
      </View>
    );
  }
}

type Props = {
  subscription: Object,
  isChangingMode: boolean,
  style?: any,
  switchMode: Function,
  switchValue: boolean,
  disabled?: boolean,
};

const getStyles = () => {
  const scaleX = I18n.rtl() ? -1 : 1;

  return StyleSheet.create({
    innerContainer: {
      padding: 10,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    normalText: {
      fontSize: 13,
      color: '#838383',
      textAlign: 'center',
    },
    strongText: {
      fontSize: 14,
      color: theme.primaryColor,
    },
    warningText: {
      color: 'orange',
      fontWeight: '600',
    },
    strongerText: {
      color: theme.primaryColor,
      fontSize: 20,
      fontWeight: '600',
      marginTop: 8,
      marginBottom: 8,
      textAlign: 'center',
    },
    switchView: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    labelView: {
      height: 40,
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginLeft: 10,
      marginRight: 0,
    },
    labelViewLoader: {
      height: 40,
      paddingTop: 10,
    },
    switchButton: {
      margin: 10,
      transform: [{scaleX}],
    },
    switchLeftText: {
      color: '#838383',
    },
    loader: {
      height: 100,
    },
    renewalDate: {
      flex: 1,
    },
    disabledText: {
      textAlign: 'center',
    },
  });
};

type State = {
  isModalOpen: boolean,
};

export default PlanRenewer;
